import type { MailboxInfo } from 'owa-client-types';
import { TasksHubSection } from '../utils/TasksHubSection';
import { getSurfacedAsyncItems, type SurfacedAsyncItem } from './getSurfacedAsyncItems';

export type EntriesBySection = Record<TasksHubSection, SurfacedAsyncItem[]>;

function getUpdateTime(item: SurfacedAsyncItem): number {
    // Sort entries with no known update time as the most recent (top of the list).
    return item.entry.updateTimeUtc ?? Number.POSITIVE_INFINITY;
}

/**
 * Returns all async items for an account grouped into the Tasks Hub sections, each sorted most-recent
 * first. `inProgress` items form the In progress section; every other surfaced state (failed /
 * needs-attention / completed) rolls up into Needs your input.
 */
export default function getEntriesBySection(mailboxInfo: MailboxInfo): EntriesBySection {
    const sections: EntriesBySection = {
        [TasksHubSection.NeedsYourInput]: [],
        [TasksHubSection.InProgress]: [],
    };

    for (const item of getSurfacedAsyncItems(mailboxInfo)) {
        const section =
            item.state === 'inProgress'
                ? TasksHubSection.InProgress
                : TasksHubSection.NeedsYourInput;
        sections[section].push(item);
    }

    const byNewest = (a: SurfacedAsyncItem, b: SurfacedAsyncItem): number => {
        const timeA = getUpdateTime(a);
        const timeB = getUpdateTime(b);
        return timeA === timeB ? 0 : timeB - timeA;
    };
    sections[TasksHubSection.NeedsYourInput].sort(byNewest);
    sections[TasksHubSection.InProgress].sort(byNewest);

    return sections;
}
